import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../Service/Baseservice";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Download from "../../../Assets/img/download.svg";
import { useLocation } from "react-router-dom";
import Loading from "../../../Loading/loading";
const ConsultationCustomerView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const pageNumber = location.state?.pageNumber || 1;
    const [admin, setAdmin] = useState(null);
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(true);
    const languageId = location.state?.language_id || 1;
    console.log("languageId", languageId)

    const getExt = (url) => url.split(".").pop().toLowerCase();
    const [showNotesList, setShowNotesList] = useState(false);
    const [notesList, setNotesList] = useState([]);
    const [notesListLoading, setNotesListLoading] = useState(false);

    /* ================= FETCH DATA ================= */
    useEffect(() => {
        if (!id) return;

        API.post("ConsultationCustomerViewEdit/condition", {
            consultation_booking_id: id,
        })
            .then((res) => {
                const row = res.data?.data?.data?.[0];
                setAdmin(row || null);
            })
            .catch((err) => console.error("View error:", err))
            .finally(() => setLoading(false));
    }, [id]);

    /* ================= HELPERS ================= */
    const parseDocs = (value) => {
        try {
            if (!value) return [];
            if (Array.isArray(value)) return value;
            if (typeof value === "string" && value.startsWith("[")) {
                return JSON.parse(value);
            }
            return [value];
        } catch (e) {
            console.error("Invalid document JSON:", value);
            return [];
        }
    };

    /* ================= DOCUMENT HANDLERS ================= */
    const openDocument = (file) => {
        if (!file) return;
        window.open(file, "_blank");
    };


    // const downloadDocument = (fileUrl) => {
    //     if (!fileUrl) return;

    //     const fileName = fileUrl.split("/").pop();

    //     // Force attachment download
    //     const downloadUrl = `${fileUrl}?response-content-disposition=attachment;filename=${fileName}`;

    //     const link = document.createElement("a");
    //     link.href = downloadUrl;
    //     link.target = "_self"; // IMPORTANT
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // };

    const downloadDocument = async (fileUrl) => {
        if (!fileUrl) return;

        try {
            const response = await fetch(fileUrl, { mode: "cors" });
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = fileUrl.split("/").pop(); // filename
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };



    const renderPreview = (url, label) => {
        const ext = getExt(url);

        if (["jpg", "jpeg", "png", "webp"].includes(ext)) {
            return <img className="image-preview" src={url} alt={label} />;
        }

        if (ext === "pdf") {
            return (
                <iframe
                    src={`${url}#toolbar=0`}
                    title={label}
                    className="pdf-iframe"
                />
            );
        }

        if (["txt", "json", "xml", "csv"].includes(ext)) {
            return (
                <iframe
                    src={`${url}#toolbar=0`}
                    title={label}
                    className="pdf-iframe"
                    style={{ backgroundColor: "white" }}
                />
            );
        }

        return (
            <div className="file-preview">
                <span className="file-icon">📄</span>
                <span>{ext.toUpperCase()} file</span>
                <small>Click download</small>
            </div>
        );
    };
    const totalAppointmentAmount = Array.isArray(admin?.paymentrequest)
        ? admin.paymentrequest.reduce((sum, item) => {
            const amount = Number(item.amount) || 0;
            return sum + amount;
        }, 0)
        : 0;

    const visiblePaymentRequests = Array.isArray(admin?.paymentrequest)
        ? admin.paymentrequest.filter(
            (p) => p.message || p.image
        )
        : [];
    const handleNotesList = () => {
        setShowNotesList(true);
        setNotesListLoading(true);

        const payload = {
            consultation_booking_id: admin.consultation_booking_id,
        };

        API.post("consultationNotesList/condition", payload)
            .then((res) => {
                if (res.data.success) {
                    setNotesList(res.data.data || []);
                }
            })
            .catch((err) => {
                console.error("Notes list error:", err);
            })
            .finally(() => {
                setNotesListLoading(false);
            });
    };

    const isValidDocument = (doc) => {
        return doc && doc !== "null" && doc !== "" && doc !== "[]";
    };

    if (loading) return <p>{languageId === 1 ? "Loading..." : "Chargement..."}</p>;

    if (!admin) return (
        <p>{languageId === 1 ? "No Data Found" : "Aucune donnée trouvée"}</p>
    );


    return (
        <div className="con-view-form-container">

            {/* ================= STEP 1 ================= */}
            {step === 1 && (
                <div className="con-form-container">
                    <div className="newsadd-header">
                        {languageId === 1 ? (
                            <h2 className="newsadd-title">Consultation Form Details</h2>) : (<h2 className="newsadd-title">Détails du formulaire de consultation</h2>)}

                        <div className="header-buttons">
                            <button
                                className="cancel-btn"
                                onClick={() => navigate("/ConsultationFromList", { state: { pageNumber } })}
                            >
                                {languageId === 1 ? "Back" : "Retour"}
                            </button>

                        </div>
                    </div>

                    <form className="intake-form">
                        <div className="intake-grid">
                            <div>
                                {languageId === 1 ? (
                                    <label>Immigration Goal</label>
                                ) : (
                                    <label>Objectif d’immigration</label>
                                )}

                                <input value={admin.heading} readOnly />
                            </div>

                            <div>
                                {languageId === 1 ? (
                                    <label>Consultation Type</label>
                                ) : (
                                    <label>Type de consultation</label>
                                )}

                                <input value={admin.consultation_type_name} readOnly />
                            </div>

                            <div>
                                {languageId === 1 ? (
                                    <label>Date & Time</label>
                                ) : (
                                    <label>Date et heure</label>
                                )}

                                <input
                                    value={`${admin.admin_date} (${admin.admin_start_time} - ${admin.admin_end_time})`}
                                    readOnly
                                />
                            </div>

                            <div>
                                {languageId === 1 ? (
                                    <label>Fees</label>
                                ) : (
                                    <label>Frais</label>
                                )}

                                <input value={admin.consultation_type_fees} readOnly />
                            </div>
                        </div>

                        <div className="next-buttons">

                            {languageId === 1 ? (
                                <button
                                    type="button"
                                    className="cancel-btn "
                                    onClick={() => setStep(2)}
                                >
                                    Next
                                </button>
                            ) :



                                (<button
                                    type="button"
                                    className="cancel-btn"
                                    onClick={() => setStep(2)}
                                >
                                    Suivant
                                </button>)}

                        </div>
                    </form>
                </div>
            )}

            {/* ================= STEP 2 ================= */}
            {step === 2 && (
                <>
                    <div className="intake-header">
                        <h2>{languageId === 1 ? "IMMIGRATION CONSULTATION INTAKE FORM" : "FORMULAIRE DE DEMANDE DE CONSULTATION EN MATIÈRE D'IMMIGRATION"}</h2>
                        <button className="cancel-btn " onClick={() => setStep(1)}>
                            {languageId === 1 ? "Back" : "Retour"}
                        </button>
                    </div>

                    <form className="intake-form">
                        <h2> {languageId === 1 ? "Personal Information" : "Informations personnelles"}</h2>
                        <div className="intake-grid">
                            {Object.entries(admin.customer || {}).map(([k, v]) => (
                                <div key={k}>
                                    <label>{k}</label>
                                    <input value={v} readOnly />
                                </div>
                            ))}
                        </div>

                        <hr />

                        <h2>{languageId === 1 ? "Background Information" : "Informations générales"}</h2>
                        <div className="intake-grid">
                            {Object.entries(admin.background || {}).map(([k, v]) => (
                                <div key={k}>
                                    <label>{k}</label>
                                    <input value={v} readOnly />
                                </div>
                            ))}
                        </div>

                        <hr />

                        <h2> {languageId === 1 ? "Supporting Documents" : "Documents justificatifs"}</h2>

                        <div className="docs-grid">
                            {Object.entries(admin.document || {}).map(([k, v]) => {
                                const files = parseDocs(v);
                                const isSingle = files.length === 1;

                                return (
                                    <div key={k} className="doc-box">
                                        <label>{k}</label>

                                        {/* ===== SINGLE DOCUMENT (FULL WIDTH LIKE SIGNATURE) ===== */}
                                        {isSingle ? (
                                            <div className="doc-box-single-content">
                                                {/* HEADER ROW */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                        alignItems: "center",
                                                        marginBottom: "10px",
                                                    }}
                                                >

                                                    <button
                                                        type="button"
                                                        onClick={() => downloadDocument(files[0])}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "6px",
                                                        }}
                                                    >
                                                        <img src={Download} alt="Download" className="icon-btn1" />
                                                        Download
                                                    </button>
                                                </div>

                                                {/* CENTERED IMAGE */}
                                                <div
                                                    className="preview-wrapper"
                                                    onClick={() => openDocument(files[0])}
                                                    title="Click to view"
                                                >
                                                    {renderPreview(files[0], k)}
                                                </div>
                                            </div>
                                        ) : files.length > 1 ? (


                                            /* ===== MULTIPLE DOCUMENTS (2 COLUMN GRID) ===== */
                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "repeat(2, 1fr)",
                                                    gap: "15px",
                                                    maxHeight: "220px",
                                                    overflowY: "auto",
                                                    paddingRight: "5px",
                                                    marginTop: "10px",
                                                }}
                                            >
                                                {files.map((file, idx) => (
                                                    <div key={idx}>
                                                        <button
                                                            type="button"
                                                            onClick={() => downloadDocument(file)}
                                                            style={{ marginBottom: "6px" }}
                                                        >
                                                            <img
                                                                src={Download}
                                                                alt="Download"
                                                                className="download-icon"
                                                            />
                                                            Download
                                                        </button>

                                                        <div
                                                            className="preview-wrapper"
                                                            onClick={() => openDocument(file)}
                                                            title="Click to open"
                                                        >
                                                            {renderPreview(file, `${k}-${idx}`)}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )
                                            : <div className="justify-content-center"><span>No documents available</span></div>}
                                    </div>
                                );
                            })}
                        </div>




                        <hr />

                        <h3>{languageId === 1 ? "Payment Information" : "Informations de paiement"}</h3>
                        <div className="intake-grid">
                            {Object.entries(admin.payment || {}).map(([k, v]) => (
                                <div key={k}>
                                    <label>{k}</label>
                                    <input value={v} readOnly />
                                </div>
                            ))}
                        </div>

                        <hr />

                        <h3>{languageId === 1 ? "Signature Document" : "Document signé"}</h3>
                        <div className="docs-grid">
                            <div className="doc-box">
                                <label>Signature</label>
                                {isValidDocument(admin.signature_document) ? (
                                    <>
                                        <div className="doc-box-content">
                                            <button
                                                type="button"
                                                onClick={() => downloadDocument(admin.signature_document)}
                                            >
                                                <img
                                                    src={Download}
                                                    alt="Download"
                                                    className="icon-btn1"
                                                />
                                                Download
                                            </button>
                                        </div>
                                        <div
                                            className="preview-wrapper"
                                            onClick={() => openDocument(admin.signature_document)}
                                            title="Click to view"
                                        >
                                            {renderPreview(admin.signature_document, "Signature")}
                                        </div>
                                    </>
                                ) : (
                                    <div className="justify-content-center"><span>No documents available</span></div>
                                )}
                            </div>
                        </div>

                        {visiblePaymentRequests.length > 0 && (
                            <>
                                <div className="mt-3 mb-3">
                                    <p className="personalinformation mt-3">
                                        {languageId === 1
                                            ? "Payment Request Form"
                                            : "Formulaire de demande de paiement"}
                                    </p>
                                </div>

                                {visiblePaymentRequests.map((payment) => (
                                    <div
                                        key={payment.payment_request_form_id}
                                        className="popup-grid1 mb-3"
                                    >
                                        <div>
                                            <label className="form-label">
                                                {languageId === 1 ? "Message" : "Message"}
                                            </label>
                                            <textarea
                                                value={payment.message || ""}
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-12 col-lg-12">
                                            <label className="form-label labelinput d-block">
                                                {languageId === 1 ? "QR Code" : "Code QR"}
                                            </label>

                                            {payment.image && (
                                                <div className="mt-2">
                                                    <img
                                                        src={payment.image}
                                                        alt="QR"
                                                        style={{
                                                            maxHeight: "120px",
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}


                        {Array.isArray(admin?.paymentrequest) &&
                            admin.paymentrequest.length > 0 && (
                                <>
                                    <div className="mt-3 mb-3">
                                        <p className="personalinformation mt-3">
                                            {languageId === 1
                                                ? "Booking Confirmation"
                                                : "Confirmation de rendez-vous"}
                                        </p>
                                    </div>

                                    <div className="booking-content">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {languageId === 1
                                                    ? "Appointment Amount"
                                                    : "Montant du rendez-vous"}
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={`$ ${totalAppointmentAmount}`}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        <div className="d-flex justify-content-end mt-4 mb-2">
                            <button
                                className="cancel-btn "
                                type="button"
                                onClick={handleNotesList}
                            >
                                {languageId === 1 ? "Notes" : "Remarques"}
                            </button>
                        </div>

                    </form>
                </>
            )}
            {showNotesList && (
                <div className="popup-overlay-notes">
                    <div className="popup-box-notes">
                        <h5 className="mb-3">
                            {languageId === 1 ? "Notes List" : "Liste des notes"}
                        </h5>

                        {notesListLoading ? (
                            <Loading />
                        ) : notesList.length > 0 ? (
                            <ul className="list-group">
                                {notesList.map((note) => (
                                    <li
                                        key={note.consultation_notes_id}
                                        className="list-group-item"
                                    >
                                        <div className="d-flex justify-content-between align-items-start">
                                            <p className="mb-0 text-start">{note.notes}</p>
                                            <small className="text-muted ms-3 text-end">
                                                {new Date(note.createdAt).toLocaleString()}
                                            </small>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-muted">
                                {languageId === 1
                                    ? "No notes found"
                                    : "Aucune note trouvée"}
                            </p>
                        )}

                        <div className="d-flex justify-content-end mt-3">
                            <button
                                className="send-btn"
                                onClick={() => setShowNotesList(false)}
                            >
                                {languageId === 1 ? "Close" : "Fermer"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default ConsultationCustomerView;
